import { defineComponent as _defineComponent } from 'vue'
import { PaginatedQuery, Trade, openTradeStates, getCurrencyPair, formatHedgingInstrument } from 'ah-api-gateways';
import { tradeReportTableFieldsFull } from 'ah-trades/src/models/tradeTableFields';
import TradeNotionalValueCell from 'ah-trades/src/components/tableCells/TradeNotionalValueCell.vue';
import TradeFxRateCell from 'ah-trades/src/components/tableCells/TradeFxRateCell.vue';
import { formatDate, SIMPLE_DATE_FORMAT } from 'ah-common-lib/src/helpers/time';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { PropType, computed } from 'vue';
import { useTradeState } from '../..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';

interface TradeEmits extends UseManagedListingEmits<Trade> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenPositionsTradeListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    required: false,
    default: () => ({ tableFields: tradeReportTableFieldsFull }),
  },
  hidePagination: {
    type: [Boolean, String],
    required: false,
    default: false,
  },
  ...defineUseManagedListingProps<Trade>(),
},
  setup(__props, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;





const tradeState = useTradeState();

const managedListing = useManagedListing<Trade>({
  loadDataRequest(query: PaginatedQuery) {
    return tradeState.services.trade.listTrades({ ...query, state: openTradeStates });
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: useRequestManager().manager,
});

return { __sfc: true,props, emit, tradeState, managedListing, getCurrencyPair, formatHedgingInstrument, TradeNotionalValueCell, TradeFxRateCell, formatDate, SIMPLE_DATE_FORMAT }
}

})